import { useState, useEffect } from "react"

// Helper function to get initial domain
const getInitialDomain = (
  defaultDomain: string
): string => {
  // If we're on the client, use window.location.host immediately
  if (typeof window !== "undefined") {
    const host = window.location.host

    // If localhost, use the default domain instead
    if (host.startsWith("localhost")) {
      return defaultDomain
    }

    return host
  }

  // Otherwise use the default (server-side)
  return defaultDomain
}

export const useDomain = (
  defaultDomain: string = import.meta.env.VITE_DEFAULT_DOMAIN ||
    "sandbox.sancor.portal.pay2b.net"
) => {
  // Initialize with the correct domain from the start
  const [domain, setDomain] = useState<string>(() =>
    getInitialDomain(defaultDomain)
  )

  useEffect(() => {
    const isClient = typeof window !== "undefined"

    if (isClient) {
      const currentHost = window.location.host

      // If localhost, use default domain
      const resolvedDomain = currentHost.startsWith("localhost")
        ? defaultDomain
        : currentHost

      // Only update if different from current state
      if (resolvedDomain !== domain) {
        setDomain(resolvedDomain)
      }
    }
  }, [defaultDomain, domain])

  return domain
}
